













































































































import { Component, Vue } from "vue-property-decorator";
import { mdiTwitter, mdiFacebook } from "@mdi/js";

@Component
export default class Support extends Vue {
  twitterIconPath = mdiTwitter;
  facebookIconPath = mdiFacebook;
}
